import { generate as generateUniqueName } from 'randomstring'
import { PUBLIC_PREFIX } from 'constants/images'
import client from 'configs/apolloClient'
import { GET_SIGNED_URL } from '../queries/common'
import { DIVIDE_SIGN } from './getFileNameFromImagekitLink'

export const uploadImage = async (file: File, pathS3: string, isFullPath?: boolean) => {
  try {
    if (file) {
      const fileName = `${generateUniqueName()}${DIVIDE_SIGN}${file.name}`

      const response = await client.query({
        query: GET_SIGNED_URL,
        variables: {
          query: {
            contentType: file.type,
            fileName: fileName,
            method: 'putObject',
            path: pathS3,
          },
        },
      })

      const encodedFileName = encodeURIComponent(fileName)

      const putResponse = await fetch(response.data.getSignedUrls, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type,
          'Content-Disposition': `attachment; filename*=UTF-8"${encodedFileName}"`,
        },
        body: file,
      })

      if (!putResponse.ok) {
        throw new Error(`Failed to upload image to S3: ${putResponse.status} ${putResponse.statusText}`)
      }

      if (isFullPath) {
        return `${process.env.REACT_APP_IMAGEKIT_URL}/tr:h-default,w-default/${pathS3}/${fileName}`
      }

      const path = pathS3.replace(`${PUBLIC_PREFIX}/`, '')
      return `${path}/${fileName}`
    }
  } catch (e) {
    console.error(e)
  }
}

export const useImageUpload = () => uploadImage
